// extracted by mini-css-extract-plugin
export default {"wrap":"OQZw6","nav-button":"ho4Yu","navButton":"ho4Yu","date":"TgIah","notation":"kLOIZ","nav-button-icon-back":"yXWEt","navButtonIconBack":"yXWEt"};